"use client";
import { useWindowDimension } from "@/hooks/dim-hook";

const WindowDimensions = () => {
  useWindowDimension();

  return <></>;
};

export default WindowDimensions;
